var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoutMobileIcon = function SvgLogoutMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21.007
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.575 13.759a1.05 1.05 0 0 1 1.407.473 8.4 8.4 0 1 0 0-7.457 1.057 1.057 0 1 1-1.887-.945 10.5 10.5 0 1 1 0 9.347 1.05 1.05 0 0 1 .483-1.418ZM1.05 9.453h10.072L8.706 7.048a1.055 1.055 0 1 1 1.489-1.491l4.2 4.2a1.086 1.086 0 0 1 0 1.491l-4.2 4.2a1.055 1.055 0 1 1-1.491-1.491l2.416-2.405H1.05a1.05 1.05 0 0 1 0-2.1Z"
  })));
};
export default SvgLogoutMobileIcon;